export const scrollElementToTop = (element, offset) => {
    const el = document.getElementById('main-scrollable-content');
    const pos = el.scrollTop;
    const rect = element.getBoundingClientRect();

    el.scroll({
        top: pos + rect.top + offset - 60,
        behavior: "smooth"
    });
}
